export const capitalize = str =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getStateTitle = state =>
  state.split('_').map(capitalize).join('-');



// WEBPACK FOOTER //
// ./src/utils/textFormat.js